import React, { ReactElement } from 'react'
import { NightlyButton } from '../../../buttons/NightlyButton/NightlyButton'
import { IconChevronUpTN } from '../../../icons'
import {
    BackToTopWrapper,
    SectionContentContainer,
} from './SectionContent.styled'

export type SectionContentProps = {
    content: {
        children: ReactElement
    }
}

export const SectionContent = ({ content }: SectionContentProps) => {
    return (
        <SectionContentContainer>
            {content.children}
            <BackToTopWrapper>
                <NightlyButton
                    variant={'default'}
                    text={'back to top'}
                    action={{
                        type: 'button',
                        onClick: () => {
                            window.scrollTo({ top: 0 })
                        },
                    }}
                    color={'primary'}
                    fill={'text'}
                    icon={{
                        IconElement: <IconChevronUpTN />,
                        iconPosition: 'right',
                    }}
                />
            </BackToTopWrapper>
        </SectionContentContainer>
    )
}
